module.exports = __webpack_public_path__ + "img/neotag_unit_blue-01.a9e30081.svg";